import { fixedUi } from '@/i18n/fixedUi';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export function displayValue(value) {
  if (value == null) return '—';
  const text = String(value).trim();
  return text || '—';
}

function KvTable({ rows }) {
  if (!rows.length) {
    return <p className="tko-return-detail__empty">{fixedUi("暂无数据")}</p>;
  }
  return (
    <table className="tko-return-detail__kv">
      <tbody>
        {rows.map((row) => (
          <tr key={row.key || row.label}>
            <th scope="row">{row.label}</th>
            <td title={row.value === '—' ? undefined : row.value}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/**
 * 模板库详情弹窗（只读）：分段标题 + 左标签右数值表格（对齐店铺信息页布局）。
 * 仓库模板 / 运费模板等本地同步缓存详情共用。
 *
 * @param {{
 *   open: boolean,
 *   title: string,
 *   subtitle?: string,
 *   sections: Array<{ key: string, title: string, rows: Array<{ key?: string, label: string, value: any }> }>,
 *   onClose?: () => void,
 * }} props
 */
export default function TemplateKvDetailModal({
  open = false,
  title = fixedUi('详情'),
  subtitle = '',
  sections = [],
  onClose,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="tko-batch-modal tko-cert-json-modal" role="presentation">
      <button
        type="button"
        className="tko-batch-modal__backdrop"
        aria-label={fixedUi("关闭")}
        onClick={onClose}
      />
      <div
        className="tko-batch-modal__panel tko-cert-json-modal__panel tko-template-kv-detail__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tko-template-kv-detail-title"
      >
        <div className="tko-batch-modal__head">
          <div>
            <h2 id="tko-template-kv-detail-title">{title}</h2>
            {subtitle ? (
              <p className="tko-batch-modal__hint" style={{ margin: '4px 0 0' }}>{subtitle}</p>
            ) : null}
          </div>
          <button type="button" className="tko-batch-modal__close" onClick={onClose} aria-label={fixedUi("关闭")}>
            ×
          </button>
        </div>

        <div className="tko-batch-modal__body tko-cert-json-modal__body tko-template-kv-detail__body">
          {(sections || []).map((section) => (
            <section className="tko-return-detail__section" key={section.key || section.title}>
              <h2 className="tko-return-detail__section-title">{section.title}</h2>
              <KvTable rows={section.rows || []} />
            </section>
          ))}
        </div>

        <div className="tko-batch-modal__foot">
          <button type="button" className="tko-btn tko-btn--primary" onClick={onClose}>
            {fixedUi("关闭")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
